import { render } from "./PopularCoursesCarousel.vue?vue&type=template&id=540e61bf&scoped=true"
import script from "./PopularCoursesCarousel.vue?vue&type=script&lang=js"
export * from "./PopularCoursesCarousel.vue?vue&type=script&lang=js"

import "./PopularCoursesCarousel.vue?vue&type=style&index=0&id=540e61bf&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-540e61bf"]])

export default __exports__